module.exports = __webpack_public_path__ + "static/media/person-circle-outline.36fe5eac.svg";